module.exports = __webpack_public_path__ + "img/app.1dc947fd.png";